import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import MuiGrid from '@mui/material/Grid2';
import MuiButton from '@mui/material/Button';
const timerStyles = ({ startCountdown, timer }) => ({
    default: {
        visibility: !startCountdown || !timer ? 'hidden' : 'initial',
        background: '#F04124',
        color: '#FFFFFF',
        fontSize: '0.85rem',
        left: '50%',
        padding: '0.25rem 0.75rem',
        position: 'fixed !important',
        top: 0,
        zIndex: 1000,
        transform: 'translate(-50%, 50%)',
        width: '10rem',
    },
});
const CountdownTimerComponent = ({ countdown = 120, // 2 minutes in seconds
logout = undefined, logoutUrl = '/', reset, setStartCountdown, startCountdown, timeOutButtonText = 'Extend', timeOutText = 'Time out in:', }) => {
    const [timer, setTimer] = useState(countdown);
    const timerClasses = timerStyles({
        startCountdown,
        timer,
    });
    const id = React.useRef(null);
    const clear = () => {
        if (id.current !== null) {
            window.clearInterval(id.current);
        }
    };
    const minutes = (() => {
        const mins = Math.floor(timer / 60);
        if (mins >= 10) {
            return mins;
        }
        return `0${mins}`;
    })();
    const seconds = (() => {
        const adjustedSeconds = timer % 60;
        if (timer % 60 === 0) {
            return '00';
        }
        return adjustedSeconds < 10 ? `0${adjustedSeconds}` : adjustedSeconds;
    })();
    useEffect(() => {
        if (startCountdown) {
            id.current = window.setInterval(() => {
                setTimer((time) => time - 1);
            }, 1000);
            return () => clear();
        }
        return () => { };
    }, [startCountdown]);
    useEffect(() => {
        if (timer === 0) {
            clear();
        }
    }, [timer]);
    if (timer === 0) {
        if (logout) {
            logout();
        }
        else {
            window.location.replace(logoutUrl);
        }
    }
    return (_jsxs(MuiGrid, { sx: timerClasses.default, container: true, id: "countdown", justifyContent: "center", children: [_jsx(MuiGrid, { children: `${timeOutText} ${minutes}:${seconds}` }), _jsx(MuiButton, { onClick: () => {
                    if (reset) {
                        reset();
                    }
                    if (setStartCountdown) {
                        setStartCountdown(false);
                    }
                    setTimer(countdown);
                }, children: timeOutButtonText })] }));
};
export default CountdownTimerComponent;
//# sourceMappingURL=countdown-timer.js.map